import ParserConfig from "./ParserConfig";

const SensorParserConfig = () => {
  return <ParserConfig deviceTypeId={1} />;
};

export default SensorParserConfig;
